import logo from "../assets/img/logo-tabsters.jpg";

const Header = () => {
  return (
    <div className="header">
      <img src={logo} alt="logo tabsters" />
    </div>
  );
};

export default Header;
